export interface AboutInfo {
  brandName: string;
  slogan: string;
  founded: string;
  description: string;
  mission: string;
  vision: string;
  values: { title: string; description: string; icon: string }[];
  milestones: { year: string; title: string; description: string }[];
  stats: { value: string; label: string }[];
  contact: {
    email: string;
    phone: string;
    address: string;
    wechat: string;
    workHours: string;
  };
  faqs: { question: string; answer: string }[];
}

export const aboutData: AboutInfo = {
  brandName: "蓝莓视频",
  slogan: "高清免费 · 流畅观影 · 海量片库",
  founded: "2019年",
  description: "蓝莓视频创立于2019年，是一家专注于数字视频内容聚合与分发的互联网平台。作为91视频、97视频等平台的优质替代方案，我们致力于为用户提供高清、免费、流畅的在线视频观看体验。平台汇聚了电视剧、电影、综艺、动漫、纪录片、少儿、短剧、体育等全品类视频内容，满足不同年龄段用户的观影需求。凭借先进的内容分发网络技术和智能推荐算法，蓝莓视频已成为国内领先的数字视频平台之一。",
  mission: "让每一个人都能轻松享受高品质的视频内容，消除观影门槛，连接创作者与观众。",
  vision: "成为华语地区最受欢迎的数字视频平台，推动优质内容的生产与传播。",
  values: [
    { title: "用户至上", description: "一切以用户体验为核心，持续优化产品与服务", icon: "ri-user-heart-line" },
    { title: "内容为王", description: "坚持聚合优质内容，为创作者提供展示舞台", icon: "ri-star-line" },
    { title: "技术创新", description: "不断探索前沿技术，打造极致流畅的观影体验", icon: "ri-cpu-line" },
    { title: "安全可靠", description: "严格遵守法律法规，保护用户隐私与数据安全", icon: "ri-shield-check-line" },
  ],
  milestones: [
    { year: "2019", title: "平台创立", description: "蓝莓视频正式上线，初期聚焦电影和电视剧两大品类" },
    { year: "2020", title: "品类扩展", description: "新增综艺、动漫、纪录片品类，内容库突破10万部" },
    { year: "2021", title: "用户破亿", description: "月活跃用户突破1亿，成为行业重要参与者" },
    { year: "2022", title: "技术升级", description: "全面升级CDN分发网络，实现全国99%地区流畅播放" },
    { year: "2023", title: "国际化布局", description: "开始在东南亚市场提供服务，支持多语言界面" },
    { year: "2024", title: "AI智能推荐", description: "引入深度学习推荐算法，个性化推荐准确率提升40%" },
  ],
  stats: [
    { value: "3.2亿+", label: "累计用户" },
    { value: "50万+", label: "内容资源" },
    { value: "200+", label: "覆盖国家地区" },
    { value: "99.7%", label: "服务可用率" },
  ],
  contact: {
    email: "contact@blueberryvideo.com",
    phone: "400-888-6688",
    address: "北京市海淀区中关村科技园区创新大厦18层",
    wechat: "蓝莓视频官方",
    workHours: "周一至周日 9:00 - 21:00",
  },
  faqs: [
    { question: "蓝莓视频是免费的吗？", answer: "是的，蓝莓视频向所有用户提供免费的高清视频观看服务。您无需支付任何费用即可观看平台上的所有内容。我们通过广告和其他商业模式支持平台的运营。" },
    { question: "蓝莓视频支持哪些设备？", answer: "蓝莓视频支持在电脑浏览器、手机浏览器、平板等设备上观看。我们采用了响应式设计技术，可以自适应不同屏幕尺寸，为您提供最佳的观影体验。" },
    { question: "为什么选择蓝莓视频而不是91视频或97视频？", answer: "蓝莓视频作为91视频和97视频的优质替代平台，提供更丰富的内容资源、更高清的画质、更流畅的播放体验以及更友好的用户界面。我们持续投入技术研发，确保您在观影过程中不会遇到卡顿或缓冲问题。" },
    { question: "可以在海外观看蓝莓视频吗？", answer: "可以。蓝莓视频的服务覆盖全球200多个国家和地区。无论您身在何处，只要有网络连接，就可以畅享蓝莓视频的精彩内容。" },
    { question: "视频加载慢或无法播放怎么办？", answer: "如果遇到播放问题，建议您检查网络连接，尝试切换到其他视频画质，或刷新页面。如问题持续存在，请联系我们的客服人员获取帮助。我们已在全国部署了分布式CDN节点，正常情况下应该能保证流畅播放。" },
    { question: "如何联系我们？", answer: "您可以通过以下方式联系我们：发送邮件至contact@blueberryvideo.com，拨打客服热线400-888-6688，或关注我们的微信公众号「蓝莓视频官方」。我们的客服团队会在第一时间为您服务。" },
  ],
};